import { MuiColorInput, MuiColorInputProps } from 'mui-color-input'
import { Controller, useFormContext } from 'react-hook-form'

type Props = Omit<MuiColorInputProps, 'variant' | 'value'> & {
  name: string
  label: string
  variant?: MuiColorInputProps['variant']
}

export const FormColorPicker = ({
  name,
  label,
  format = 'hex',
  variant = 'outlined',
  fullWidth = true,
  ...rest
}: Props) => {
  const {
    control,
    formState: { errors },
  } = useFormContext()

  return (
    <Controller
      control={control}
      name={name}
      render={({ field }) => (
        <MuiColorInput
          {...rest}
          {...field}
          format={format}
          label={label}
          variant={variant}
          fullWidth={fullWidth}
          helperText={errors[name]?.message?.toString() || ''}
          error={!!errors[name]?.message}
        />
      )}
    />
  )
}
